"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.START_DICTATE = void 0;
exports["default"] = startDictate;
var START_DICTATE = 'WEB_CHAT/START_DICTATE';
exports.START_DICTATE = START_DICTATE;
function startDictate() {
  return {
    type: START_DICTATE
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTVEFSVF9ESUNUQVRFIiwiZXhwb3J0cyIsInN0YXJ0RGljdGF0ZSIsInR5cGUiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9zdGFydERpY3RhdGUuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU1RBUlRfRElDVEFURSA9ICdXRUJfQ0hBVC9TVEFSVF9ESUNUQVRFJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc3RhcnREaWN0YXRlKCkge1xuICByZXR1cm4geyB0eXBlOiBTVEFSVF9ESUNUQVRFIH07XG59XG5cbmV4cG9ydCB7IFNUQVJUX0RJQ1RBVEUgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLGFBQWEsR0FBRyx3QkFBd0I7QUFBQ0MsT0FBQSxDQUFBRCxhQUFBLEdBQUFBLGFBQUE7QUFFaEMsU0FBU0UsWUFBWUEsQ0FBQSxFQUFHO0VBQ3JDLE9BQU87SUFBRUMsSUFBSSxFQUFFSDtFQUFjLENBQUM7QUFDaEMifQ==